import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {VirtualScrollerModule} from '@iharbeck/ngx-virtual-scroller';
import {COLOR_SETS} from '@infrastructure/http/color-set/color-sets';
import {HttpColorSetsService} from '@infrastructure/http/color-set/http-color-sets.service';
import {HttpMachineQualitiesService} from '@infrastructure/http/machine-quality/http-machine-qualities.service';
import {MACHINE_QUALITIES} from '@infrastructure/http/machine-quality/machine-qualities';
import {ChangePlaceholderPartsDialogComponent} from '@presentation/components/change-placeholder-parts-dialog/change-placeholder-parts-dialog.component';
import {CreelPreviewComponent} from '@presentation/components/creel-preview/creel-preview.component';
import {PlaceholderPartsComponent} from '@presentation/components/placeholder-parts/placeholder-parts.component';
import {AddYarnComponent} from '@presentation/components/yarn/add-yarn/add-yarn.component';
import {SelectColorSetComponent} from '@presentation/pages/textile-data/colored-yarn-set/add/select-color-set/select-color-set.component';
import {GridCompatibleWithMachineQualityComponent} from '@presentation/pages/textile-data/finishing/add/select-machine-quality-and-finishing-template/grid-compatible-with-machine-quality/grid-compatible-with-machine-quality.component';
import {AddMaterialSetPageComponent} from '@presentation/pages/textile-data/material-set/add/add-material-set-page.component';
import {CreelPositionDetailsComponent} from '@presentation/pages/textile-data/material-set/add/creel-position-details/creel-position-details.component';
import {MaterialTypeGroupComponent} from '@presentation/pages/textile-data/material-set/add/creel-position-details/group/material-type-group.component';
import {MaterialTypeComponent} from '@presentation/pages/textile-data/material-set/add/creel-position-details/material-type/material-type.component';
import {CreelPositionComponent} from '@presentation/pages/textile-data/material-set/add/creel-positions/creel-position/creel-position.component';
import {PreviewForCreelPositionComponent} from '@presentation/pages/textile-data/material-set/add/creel-positions/creel-position/preview-for-creel-position/preview-for-creel-position.component';
import {CreelPositionsComponent} from '@presentation/pages/textile-data/material-set/add/creel-positions/creel-positions.component';
import {SelectColorComponent} from '@presentation/pages/textile-data/material-set/add/select-color/select-color.component';
import {SelectYarnTypeComponent} from '@presentation/pages/textile-data/material-set/add/select-yarn-type/select-yarn-type.component';
import {SharedModule} from '@shared/shared.module';
import {ColorPickerModule} from '@vdw/angular-component-library';
import {AgGridModule} from 'ag-grid-angular';
import {SelectWeavePatternTemplateComponent} from './weave-structure/add/select-weave-pattern-template-and-add-weave-pattern-form/select-weave-pattern-template.component';
import {OverviewListWeaveStructureService} from './weave-structure/overview/overview-list-weave-structure.service';
import {OverviewListYarnSetService} from './yarn-set/overview/overview-list-yarn-set.service';

@NgModule({
  imports: [AgGridModule, SharedModule, VirtualScrollerModule, ColorPickerModule, RouterModule],
  providers: [
    {provide: MACHINE_QUALITIES, useClass: HttpMachineQualitiesService},
    {provide: COLOR_SETS, useClass: HttpColorSetsService},
    OverviewListYarnSetService,
    OverviewListWeaveStructureService
  ],
  declarations: [
    CreelPositionsComponent,
    CreelPositionComponent,
    PreviewForCreelPositionComponent,
    CreelPositionDetailsComponent,
    MaterialTypeGroupComponent,
    CreelPreviewComponent,
    SelectColorSetComponent,
    SelectColorComponent,
    SelectYarnTypeComponent,
    AddMaterialSetPageComponent,
    GridCompatibleWithMachineQualityComponent,
    MaterialTypeComponent,
    PlaceholderPartsComponent,
    ChangePlaceholderPartsDialogComponent,
    SelectWeavePatternTemplateComponent,
    ChangePlaceholderPartsDialogComponent,
    AddYarnComponent
  ],
  exports: [
    CreelPositionsComponent,
    CreelPositionComponent,
    PreviewForCreelPositionComponent,
    CreelPositionDetailsComponent,
    CreelPreviewComponent,
    MaterialTypeGroupComponent,
    VirtualScrollerModule,
    SelectColorComponent,
    SelectYarnTypeComponent,
    AddMaterialSetPageComponent,
    SharedModule,
    AgGridModule,
    SelectColorSetComponent,
    GridCompatibleWithMachineQualityComponent,
    MaterialTypeComponent,
    PlaceholderPartsComponent,
    ChangePlaceholderPartsDialogComponent,
    SelectWeavePatternTemplateComponent,
    AddYarnComponent
  ]
})
export class TextileDataSharedModule {}
